import { render, staticRenderFns } from "./jurnalumum.vue?vue&type=template&id=2042d662&scoped=true&"
import script from "./jurnalumum.vue?vue&type=script&lang=js&"
export * from "./jurnalumum.vue?vue&type=script&lang=js&"
import style0 from "./jurnalumum.vue?vue&type=style&index=0&id=2042d662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042d662",
  null
  
)

export default component.exports